import React, { useCallback } from 'react';
import MuiMenuList from '@material-ui/core/MenuList';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { Notification } from 'types';

import { useNotificationsListStyles } from './notifications-styles';
import { NotificationsListItem } from './notifications-list-item';

export const NotificationsList = React.forwardRef(
  (
    {
      count,
      readNotifications,
      readAll,
      notifications,
      handleClose,
    }: {
      count: number;
      notifications: Notification[];
      readAll: () => Promise<boolean>;
      readNotifications: (ids: string[]) => Promise<boolean>;
      handleClose: () => void;
    },
    ref
  ) => {
    const classes = useNotificationsListStyles();
    const readAllNotifications = useCallback(async () => {
      readAll();
      handleClose();
    }, [handleClose, readAll]);

    return (
      <>
        {count > 0 && (
          <div className={classes.btns}>
            <Button onClick={readAllNotifications}>
              <Typography classes={{ root: classes.btnLabel }}>
                Označit vše přečteno
              </Typography>
            </Button>
            {/* Všechny notifikace */}
          </div>
        )}

        <MuiMenuList className={classes.list} innerRef={ref}>
          {notifications.map((notification) => (
            <NotificationsListItem
              key={notification.id}
              notification={notification}
              readNotifications={readNotifications}
            />
          ))}
        </MuiMenuList>
      </>
    );
  }
);
